module.exports = __webpack_public_path__ + "img/orzechowy.c4740537.jpg";